// extracted by mini-css-extract-plugin
module.exports = {"bodyText":"JRqsaz-","h5Text":"_2YS34fm","h4Text":"_318Rw2K","h3Text":"_2kaPMs7","srOnly":"_2G594VU","link":"IcvdSzY JRqsaz-","USSalesTax":"_1aqDVfV"};